import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import BannerSlide from './BannerSlide';
import { bannersAPI } from '../services/api';
import { i18n } from '../services/i18n';

const BannerCarousel = () => {
  const [banners, setBanners] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    bannersAPI.getActive().then(setBanners).catch(() => setBanners([]));
  }, []);

  useEffect(() => {
    if (banners.length < 2) return undefined;
    const interval = setInterval(() => setCurrentSlide((prev) => (prev + 1) % banners.length), 5000);
    return () => clearInterval(interval);
  }, [banners.length]);

  if (banners.length === 0) return null;

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % banners.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + banners.length) % banners.length);

  return (
    <div className="bg-gray-100 pb-6" data-testid="banner-carousel">
      <div className="max-w-7xl mx-auto px-4">
        <div className="relative overflow-hidden rounded-lg">
          <div className="flex transition-transform duration-500 ease-out" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
            {banners.map((banner, idx) => (
              <BannerSlide key={banner.id} banner={banner} testId={`banner-slide-${idx}`} />
            ))}
          </div>

          {banners.length > 1 && (
            <>
              <button data-testid="banner-prev" onClick={prevSlide} aria-label={i18n.t('banner.prev')} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 rounded-full p-2 transition-colors">
                <ChevronLeft size={24} className="text-white" />
              </button>
              <button data-testid="banner-next" onClick={nextSlide} aria-label={i18n.t('banner.next')} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 rounded-full p-2 transition-colors">
                <ChevronRight size={24} className="text-white" />
              </button>
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
                {banners.map((b, idx) => (
                  <button key={b.id} data-testid={`banner-dot-${idx}`} onClick={() => setCurrentSlide(idx)} aria-label={i18n.t('banner.n', { n: idx + 1 })}
                          className={`w-3 h-3 rounded-full transition-colors ${idx === currentSlide ? 'bg-white' : 'bg-white/50'}`} />
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BannerCarousel;
